import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'la-contextual-toolbar',
  templateUrl: './contextual-toolbar.component.html',
  styleUrls: ['./contextual-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ContextualToolbarComponent {}
